import React from 'react';
interface BibleStickyBarProps {
  href: string;
  onClick: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}
export function BibleStickyBar({
  href,
  onClick
}: BibleStickyBarProps) {
  return <div className="fixed bottom-0 left-0 z-20 w-full border-t border-[#2c2a30] bg-[#101013f5] py-3 backdrop-blur-xl" data-id="element-28" data-mp="j7wbviflr8ms">
      <div className="mx-auto flex w-[calc(100%-36px)] max-w-[1120px] items-center justify-between gap-3 md:w-[calc(100%-48px)] md:gap-5" data-id="element-29" data-mp="e9kzazxxak0v">
        <div data-id="element-30" data-mp="3mpwlt34pxo31">
          <strong className="text-[12px] md:text-[14px]" data-id="element-31" data-mp="3hp08y02e2rlh">
            Visual Disruption Bible 2.0
          </strong>
          <p className="m-0 text-[10px] text-[#beb9b0] md:text-[13px]" data-id="element-32" data-mp="hekbh6iaj30">
            PDF + comunidad · $11.99
          </p>
        </div>
        <a href={href} onClick={onClick} className="bible-cta max-w-[190px] min-h-[44px] px-[22px] py-3 text-[12px] md:max-w-none md:text-[13px]" data-id="element-33" data-mp="3rllcsi2o9wnq">
          Acceder por $11.99 →
        </a>
      </div>
    </div>;
}